import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import type { SocialPlayerSharedData } from '../../SocialPlayerShared/SocialPlayersShared.types';
import type { BaseDataItem } from '@wix/editor-elements-definitions';
import type { CompDefinition } from '@wix/editor-elements-types/thunderbolt';

export type SocialPlayerVimeoDefinition = CompDefinition<
  never,
  SocialPlayerSharedData & BaseDataItem,
  never,
  never
>;
export const props = withCompInfo<
  SocialPlayerSharedData,
  SocialPlayerVimeoDefinition
>()(['compData'], ({ compData }) => compData);

export default createComponentMapperModel({
  props,
});
